import { GetAllResponsiblesInDto } from '../../../types/responsible.dto'

export const GET_ALL_RESPONSIBLES_STATICS = 'GET_ALL_RESPONSIBLES_STATICS'
export const GET_ALL_RESPONSIBLES_STATICS_SUCCESS = 'GET_ALL_RESPONSIBLES_STATICS_SUCCESS'
export const GET_ALL_RESPONSIBLES_STATICS_ERROR = 'GET_ALL_RESPONSIBLES_STATICS_ERROR'
export const RESET_GET_ALL_RESPONSIBLES_STATICS = 'RESET_GET_ALL_RESPONSIBLES_STATICS'

export interface GetAllResponsiblesStatics {
  type: typeof GET_ALL_RESPONSIBLES_STATICS
  payload: null
}

export interface GetAllResponsiblesStaticsSuccess {
  type: typeof GET_ALL_RESPONSIBLES_STATICS_SUCCESS
  payload: GetAllResponsiblesInDto
}

export interface GetAllResponsiblesStaticsError {
  type: typeof GET_ALL_RESPONSIBLES_STATICS_ERROR
  payload: string | boolean
}

export interface ResetGetAllResponsiblesStatics {
  type: typeof RESET_GET_ALL_RESPONSIBLES_STATICS
  payload: null
}

export interface State {
  data: GetAllResponsiblesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllResponsiblesStatics
  | GetAllResponsiblesStaticsSuccess
  | GetAllResponsiblesStaticsError
  | ResetGetAllResponsiblesStatics
